/* unplugin-vue-components disabled */import { render } from "./tenant-settings.vue?vue&type=template&id=6161eac4&scoped=true"
import script from "./tenant-settings.vue?vue&type=script&lang=js"
export * from "./tenant-settings.vue?vue&type=script&lang=js"

import "./tenant-settings.vue?vue&type=style&index=0&id=6161eac4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6161eac4"],['__file',"src/pages/tenants/settings/tenant-settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6161eac4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6161eac4', __exports__)) {
    api.reload('6161eac4', __exports__)
  }
  
  module.hot.accept("./tenant-settings.vue?vue&type=template&id=6161eac4&scoped=true", () => {
    api.rerender('6161eac4', render)
  })

}


export default __exports__